import type { FaireProductEntity } from "../../entity_types/product";

export const p_7ztnv97z3d: FaireProductEntity = {
  token: "p_7ztnv97z3d",
  type: "product",
  name: "Cookie Gluten-Free Chocolate Chip Cookies Freshly Baked (12)",
  brandToken: "b_rcvdagzk6f",
  brandName: "PHIVI BOX",
  imageUrl:
    "https://cdn.faire.com/fastly/53c8928934329771c9d3bdaa816d585516eb78b978987767cbbb36edf5870976.png",
  galleryImageUrls: [],
  priceDollars: 2.76,
  description:
    "Freshly baked and handmade cookies by Phivi Artisanal Desserts Box based in New York, NY. Made in the United States of America.\n\nOur cookies are:\n- NYC style, gooey and epic! \n- Made with 100% premium ingredients\n- Always freshly baked by hand\n\nEach cookie weighs approximately 100 grams and is individually packaged with a nutrition label.\n\nOur cookies can be kept at room temperature for up to two weeks but may be stored in a freezer when not actively on display. They have a shelf life of approximately 3 months when stored in the freezer. \n\nWe ship via FedEx Ground on Mondays, Tuesdays, or Wednesdays to ensure our cookies arrive fresh to you.\n\nShop all of our flavors:\n- Classic Chocolate Chip Cookie\n- Gluten-Free Chocolate Chip Cookie\n- Dubai Chocolate Cookie\n- Ube White Chocolate Chip Cookie",
  tags: [],
  msrpDollars: 5.52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:19.014Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
